import React from "react";
import ArrestWarrantTable from "./ArrestWarrantTable/ArrestWarrantTable";

export default function ArrestWarrantCard(props) {
    const { arrest_warrant_data } = props
    const hasSource = Object.keys(arrest_warrant_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                Mandado de Prisão - Match encontrado
            </p>
            <ArrestWarrantTable arrest_warrant_data={arrest_warrant_data.source} />
        </div>
    )
}
